import React, { useState, useEffect } from "react";
import { FormControl, Alert, TextField, Grid2, Typography, Button } from '@mui/material';

export default function ConnectionNotSupportedForm({ connection, onDataChange, validationError, setValidationError }) {
    const [toEncData, setToEncData] = useState('');
    const [encryptedData, setEncryptedData] = useState('');
    const [loadingEncrypt, setLoadingEncrypt] = useState(false);

    async function encryptValue(value) {
        try {
            setLoadingEncrypt(true);
            const response = await fetch('/api/encryption/encrypt', {
                method: 'POST',
                credentials: 'include',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ value: value }),
            });
            if (response.ok) {
                const result = await response.json();
                return result.encryptedText;
            } else {
                console.error('Encryption failed');
                return value; // Return original value if encryption fails
            }
        } catch (error) {
            console.error('Error during encryption:', error);
            return value; // Return original value on error
        } finally {
            setLoadingEncrypt(false);
        }
    }

    const handleDataChange = (event) => {
        const newData = event.target.value;
        const elementId = event.target.id;
        let parsedData = {};
        try {
            parsedData = JSON.parse(newData);
            setValidationError(prev => ({ ...prev, [elementId]: null }));
        } catch (e) {
            setValidationError(prev => ({ ...prev, [elementId]: 'Invalid JSON format' }));
            return;
        }

        onDataChange && onDataChange(parsedData);
    }

    const handleInputChange = (event) => {
        const newValue = event.target.value;
        setToEncData(newValue);
        setEncryptedData(''); // Clear encrypted data when input changes
    }

    const handleEncrypt = async () => {
        if (!toEncData) {
            setEncryptedData('');
            return;
        }
        const encrypted = await encryptValue(toEncData);
        setEncryptedData(encrypted);
    }

    return (
        <div>
            <Alert severity="warning">This connection type is not yet supported as form. Please be carefull while using the JSON editor</Alert>
            <FormControl fullWidth margin="normal">
                <TextField
                    error={validationError[`connection-data-${connection.id}`] != null}
                    helperText={validationError[`connection-data-${connection.id}`]}
                    label="Connection Data (JSON)"
                    id={`connection-data-${connection.id}`}
                    name={`connection-data-${connection.id}`}
                    type="text"
                    defaultValue={connection.data || '{}'}
                    multiline
                    minRows={4}
                    maxRows={10}
                    onChange={handleDataChange}
                />
            </FormControl>
            <Typography variant="body2" color="textSecondary" style={{ marginTop: '8px' }}>
                Encryption helper
            </Typography>
            <div style={{ marginTop: '8px', marginBottom: '16px', border: '1px solid #ccc', padding: '16px', borderRadius: '10px' }}>
                <Grid2 container spacing={2} columns={16}>
                    <Grid2 size={8}>
                        <FormControl fullWidth margin="normal">
                            <TextField
                                label="input"
                                id={`input-enc`}
                                name={`input-enc`}
                                type="text"
                                multiline
                                value={toEncData}
                                minRows={3}
                                maxRows={3}
                                onChange={handleInputChange}
                            />
                        </FormControl>
                    </Grid2>
                    <Grid2 size={8}>
                        <FormControl fullWidth margin="normal">
                            <TextField
                                label="output data"
                                id={`output-enc`}
                                name={`output-enc`}
                                type="text"
                                multiline
                                value={encryptedData}
                                minRows={3}
                                maxRows={3}
                                readOnly
                            />
                        </FormControl>
                    </Grid2>
                </Grid2>
                <Button variant="contained" color="primary" onClick={handleEncrypt} disabled={loadingEncrypt} style={{ marginTop: '10px', marginBottom: '16px' }}>
                    Encrypt
                </Button>
            </div>
        </div>
    );
}

